// extracted by mini-css-extract-plugin
module.exports = {"buttonBlock":"ButtonBlock_buttonBlock__3bK3l","button":"ButtonBlock_button__qJDnw"};